import React from 'react';

import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Button as AntdButton,
  Dropdown as AntdDropdown,
  Menu as AntdMenu,
} from 'antd';

import { BrancheDto } from 'lib_api/lib/api/gen';

interface CreateDossierButtonProps {
  listBranches: BrancheDto[];
  onClick: (branche: BrancheDto) => void;
}

const CreateDossierButton = ({
  listBranches,
  onClick,
}: CreateDossierButtonProps): React.ReactElement => {
  const buttonLabel = 'Créer une nouvelle fiche véhicule';

  if (listBranches.length === 1) {
    const singleBranche = listBranches[0];
    return (
      <AntdButton
        onClick={() => onClick(singleBranche)}
        type="primary"
        shape="round"
      >
        <PlusOutlined /> {buttonLabel}
      </AntdButton>
    );
  }

  const menu = (
    <AntdMenu>
      {listBranches.map((branche: BrancheDto) => {
        return (
          <AntdMenu.Item key={branche.id} onClick={() => onClick(branche)}>
            {branche.nature}
          </AntdMenu.Item>
        );
      })}
    </AntdMenu>
  );

  return (
    <AntdDropdown overlay={menu}>
      <AntdButton
        disabled={listBranches.length === 0}
        type="primary"
        shape="round"
        className="CreateDossierButton"
      >
        {buttonLabel} <DownOutlined />
      </AntdButton>
    </AntdDropdown>
  );
};

export default CreateDossierButton;
